import { localize } from "render/context/InternationalizationContext";

const WeekdayFirstLetter = {
  Monday: localize({
    en_GB: <>M</>,
    sv_SE: <>M</>,
  }),
  Tuesday: localize({
    en_GB: <>T</>,
    sv_SE: <>T</>,
  }),
  Wednesday: localize({
    en_GB: <>W</>,
    sv_SE: <>O</>,
  }),
  Thursday: localize({
    en_GB: <>T</>,
    sv_SE: <>T</>,
  }),
  Friday: localize({
    en_GB: <>F</>,
    sv_SE: <>F</>,
  }),
  Saturday: localize({
    en_GB: <>S</>,
    sv_SE: <>L</>,
  }),
  Sunday: localize({
    en_GB: <>S</>,
    sv_SE: <>S</>,
  }),
};

export const Trans = { WeekdayFirstLetter };
